import axios from "axios"
const domains = {
	"www.trekbars.com/de/geldzurück": {
		env: "prod",
		apibase: "/",
	},
	"trekbars.com/de/geldzurück": {
		env: "prod",
		apibase: "/",
	},
	"prod.fe.cam-loy-magellan-biscoff-bakery-cashback-2026-frontend.campaign-loyalty.com": {
		env: "prod",
		apibase: "/",
	},
}
export const getEnvConfig = () => {
	return domains[window.location.host] || { apibase: "/inte/" }
}
export async function getPromoLimit() {
	const env = getEnvConfig()
	return await axios
		.get(env.apibase + "checkLimit.php?cv=" + Date.now())
		.then(res => {
			return res.data.limitReached
		})
		.catch(error => {
			return error.response.status
		})
}
export async function getWeeklyLimit() {
	const env = getEnvConfig()
	return await axios
		.get(env.apibase + "checkWeeklyLimit.php?cv=" + Date.now())
		.then(res => {
			return res.data.limitReached
		})
		.catch(error => {
			return error.response.status
		})
}
export async function getWeeklyCount() {
	const env = getEnvConfig()
	return await axios
		.get(env.apibase + "checkOrder.php?cv=" + Date.now())
		.then(res => {
			let digits = res.data.weeklyOrdersLeft
			return digits
		})
		.catch(error => {
			console.error("Not able to get counter: %s", error?.response?.status ?? error)
			return [0]
		})
}
export async function checkOrderCount() {
	const env = getEnvConfig()
	return await axios
		.get(env.apibase + "checkOrder.php?cv=" + Date.now())
		.then(res => {
			let digits = Array.from(String(res.data.weeklyOrdersLeft))
			return digits.map(str => Number(str))
		})
		.catch(error => {
			console.error("Not able to get counter: %s", error?.response?.status ?? error)
			return [0, 0, 0, 0, 0]
		})
}